import { useEffect } from "react";
import { useLocation } from "react-router";

export const useScrollToTopOnNewPage = (smoothScroll: boolean = false) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: smoothScroll ? "smooth" : undefined,
    });
  }, [pathname]);

  return null;
};
